import React, { Component } from "react"
import HeaderConsumo from "../../RelatorioConsumo/components/HeaderConsumo"
import auth from "../../../utils/auth"
import cfg from '../../../utils/config'
import axios from "axios"
import Select from "../../../components/Select"

import ConfiguracoesCabecalho from "./componentsCamposGrupos/configuracoesCabecalho"
import PreVisualizacaoCabecalho from "./componentsCamposGrupos/previsualizacaoCabecalho"
import ConfiguracoesGrupos from "./componentsCamposGrupos/configuracoesGrupos"
import ConfiguracoesDados from "./componentsCamposGrupos/configuracoesDados"
import ConfiguracoesEscalas from "./componentsCamposGrupos/configuracoesEscalas"
import ConfiguracoesColunas from "./componentsCamposGrupos/configuracoesColunas"
import tourManager from "../../../tours/TourManager"

const TOUR_DEMO_EVENT = 'hdv-tour-exportacao-demo'
const EXPORTACAO_TOURS = ['novo-exportacao-dados', 'editar-exportacao-dados']
const TOUR_DEMO_CAMPO = {
    id: 'hdv-tour-demo-campo',
    descricao: 'Parâmetro de exemplo',
    identificacao: 'hdv_tour_exemplo',
    unidade: '',
    imei: 'tour',
    usuario_mqtt: '',
    monitorados: [],
}

let tourDemoRuntime = {
    injected: false,
    snapshot: null,
    setDetalhes: null,
    setEstrutura: null,
}

const isExportacaoGuidePending = () => {
    if (EXPORTACAO_TOURS.includes(tourManager.activeTourName)) return true

    try {
        return EXPORTACAO_TOURS.includes(tourManager.getMinimizedState()?.tourName)
    } catch (error) {
        return false
    }
}

const cloneValue = (value) => {
    try {
        return JSON.parse(JSON.stringify(value ?? null))
    } catch (error) {
        return value
    }
}

export const isExportacaoTourDemoCampo = (campo) => campo?.identificacao === TOUR_DEMO_CAMPO.identificacao

export const hasExportacaoTourDemoCampos = (campos) => (campos || []).some(isExportacaoTourDemoCampo)

export const isExportacaoTourDemoInjected = () => Boolean(tourDemoRuntime.injected)

const hasRealCampos = (campos) => (campos || []).some((campo) => !isExportacaoTourDemoCampo(campo))

const hasRealLayout = (estrutura = {}) => {
    if ((estrutura.colunas || []).length > 0) return true
    if ((estrutura.grupos || []).length > 0) return true
    return (estrutura.colunasCabecalho || []).some((linha) =>
        (linha || []).some((celula) => Boolean(celula?.informacao))
    )
}

const buildTourDemoEstrutura = (estrutura) => ({
    ...estrutura,
    quantidadeColunas: 2,
    quantidadeLinhasCabecalho: 1,
    quantidadeColunasCabecalho: 2,
    colunas: [
        { coluna: 1, label: 'coluna 1', formula_campo: { label: 'Parâmetro', value: 'campo' }, campo: '' },
        { coluna: 2, label: 'coluna 2', formula_campo: { label: 'Parâmetro', value: 'campo' }, campo: '' },
    ],
    grupos: [
        { descricao: 'Leituras', colspan: 0, th_colspan: 2 },
    ],
    colunasCabecalho: [[
        { informacao: 'Planilha de exemplo', linha: 0, coluna: 0, rowspan: 1, colspan: 1, disabled: false },
        { informacao: 'Período', linha: 0, coluna: 1, rowspan: 1, colspan: 1, disabled: false },
    ]],
})

class CamposGrupos extends Component {
    userInfo = auth.getUserInfo()

    state = {
        modal: false,
        campos: [],
        unidades: [],
        tourDemoInjected: false,
    }

    tourDemoSnapshot = null
    restoringTourDemo = false

    componentDidMount() {
        this.syncLayoutFromProps()
        document.addEventListener(TOUR_DEMO_EVENT, this.handleTourDemo)
        tourDemoRuntime.setDetalhes = this.props.setDetalhes
        tourDemoRuntime.setEstrutura = this.props.setEstrutura

        if (tourDemoRuntime.injected) {
            this.tourDemoSnapshot = tourDemoRuntime.snapshot
            this.setState({ tourDemoInjected: true })
        }
    }

    componentDidUpdate(prevProps) {
        tourDemoRuntime.setDetalhes = this.props.setDetalhes
        tourDemoRuntime.setEstrutura = this.props.setEstrutura

        const camposChanged = prevProps.detalhes?.campos !== this.props.detalhes?.campos
        const periodoTodoChanged = prevProps.detalhes?.periodoTodo !== this.props.detalhes?.periodoTodo
        const estruturaChegou = prevProps.estrutura !== this.props.estrutura
            && !hasRealLayout(prevProps.estrutura)
            && hasRealLayout(this.props.estrutura)

        if (camposChanged || periodoTodoChanged || estruturaChegou) {
            this.syncLayoutFromProps()
        }

        if (this.restoringTourDemo) return
        if (!this.state.tourDemoInjected && !tourDemoRuntime.injected) return
        if (!hasRealCampos(this.props.detalhes.campos)) return

        this.restoreTourDemo({ keepCampos: true })
    }

    syncLayoutFromProps = () => {
        if (this.restoringTourDemo || this.state.tourDemoInjected || tourDemoRuntime.injected) return

        const campos = this.props.detalhes?.campos || []
        if (!hasRealCampos(campos)) return

        this.getCampos(campos, this.props.detalhes.periodoTodo)
    }

    componentWillUnmount() {
        document.removeEventListener(TOUR_DEMO_EVENT, this.handleTourDemo)

        const exportacaoGuideInProgress = isExportacaoGuidePending()

        if (exportacaoGuideInProgress) return

        if (this.state.tourDemoInjected || tourDemoRuntime.injected) {
            this.restoreTourDemo({ fromUnmount: true })
        }

        if (tourDemoRuntime.setDetalhes === this.props.setDetalhes) {
            tourDemoRuntime.setDetalhes = null
            tourDemoRuntime.setEstrutura = null
        }
    }

    handleTourDemo = (event) => {
        const action = event.detail?.action
        if (action === 'apply') this.applyTourDemo()
        if (action === 'restore') this.restoreTourDemo()
    }

    applyTourDemo = () => {
        if (this.state.tourDemoInjected || tourDemoRuntime.injected) return
        if (hasRealCampos(this.props.detalhes.campos)) return

        const snapshot = {
            campos: cloneValue(this.props.detalhes.campos || []),
            estrutura: cloneValue(this.props.estrutura || {}),
            detalhes: cloneValue(this.props.detalhes || {}),
        }
        this.tourDemoSnapshot = snapshot
        tourDemoRuntime.snapshot = snapshot
        tourDemoRuntime.injected = true
        tourDemoRuntime.setDetalhes = this.props.setDetalhes
        tourDemoRuntime.setEstrutura = this.props.setEstrutura

        const estrutura = hasRealLayout(this.props.estrutura)
            ? cloneValue(this.props.estrutura)
            : buildTourDemoEstrutura(cloneValue(this.props.estrutura || {}))
        const detalhes = Object.assign({}, this.props.detalhes, { campos: [TOUR_DEMO_CAMPO] })

        this.setState({ tourDemoInjected: true })
        this.props.setDetalhes(detalhes)
        this.props.setEstrutura(estrutura)
        this.getCampos([TOUR_DEMO_CAMPO], detalhes.periodoTodo, estrutura)
    }

    restoreTourDemo = ({ keepCampos = false, fromUnmount = false } = {}) => {
        const snapshot = this.tourDemoSnapshot || tourDemoRuntime.snapshot
        if (!snapshot || (!this.state.tourDemoInjected && !tourDemoRuntime.injected)) return

        this.restoringTourDemo = true
        const camposBrutos = keepCampos ? this.props.detalhes.campos : (snapshot.campos || [])
        const campos = (camposBrutos || []).filter((campo) => !isExportacaoTourDemoCampo(campo))
        const estrutura = snapshot.estrutura || this.props.estrutura
        const detalhes = Object.assign({}, snapshot.detalhes || this.props.detalhes, { campos })
        const setDetalhes = this.props.setDetalhes || tourDemoRuntime.setDetalhes
        const setEstrutura = this.props.setEstrutura || tourDemoRuntime.setEstrutura

        this.tourDemoSnapshot = null
        tourDemoRuntime.snapshot = null
        tourDemoRuntime.injected = false

        if (!fromUnmount) {
            this.setState({ tourDemoInjected: false }, () => {
                this.restoringTourDemo = false
            })
            this.getCampos(campos, detalhes.periodoTodo, estrutura)
        } else {
            this.restoringTourDemo = false
        }

        setDetalhes?.(detalhes)
        setEstrutura?.(estrutura)
    }

    getCampos = (campos, periodoTodo, estruturaOverride) => {
        let estrutura = Object.assign({}, estruturaOverride || this.props.estrutura || {})
        const identificadores = []
        const unidades = []
        let escalas = []
        const camposLista = campos || []

        camposLista.forEach((campo) => {
            let identificacao = campo.identificacao
            let unidade = campo.unidade
            let imei = campo.imei

            if (periodoTodo) {
                identificadores.push(identificacao)
                unidades.push({ id: identificacao, unidade: unidade })
            } else {
                let escala = (estrutura.escalas || []).filter((escala) => escala.identificacao === campo.identificacao)

                escala = escala.length > 0 ? escala[0].escala : { label: "Nenhum", value: null }

                escalas.push({ campo: campo.descricao, escala: escala, identificacao: campo.identificacao, usuario_mqtt: campo.usuario_mqtt, imei: campo.imei })

                identificadores.push(`${imei}_` + identificacao + "_inicial")
                identificadores.push(`${imei}_` + identificacao + "_final")
                unidades.push({ id: `${imei}_` + identificacao + "_inicial", unidade: unidade })
                unidades.push({ id: `${imei}_` + identificacao + "_final", unidade: unidade })

                if (escala.value != null) {
                    identificadores.push(`${imei}_` + identificacao + "_" + escala.value)
                    unidades.push({ id: `${imei}_` + identificacao + "_" + escala.value, unidade: unidade })
                }
            }
        })

        if (camposLista.length === 0) {
            escalas = []
        }

        estrutura['escalas'] = escalas

        this.props.setEstrutura(estrutura)
        this.setState({ campos: identificadores, unidades: unidades, estrutura })
    }

    adicionarCampos = (itens) => {
        let detalhes = Object.assign({}, this.props.detalhes)

        let bodyFormData = new FormData()
        let campos = []
        let userInfo = auth.getUserInfo()

        for (let campo of itens) {
            campos.push(campo.value)
        }

        bodyFormData.append('campos', campos)

        if (this.props.edit) {
            axios({
                method: 'PATCH',
                url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/exportacao-dados/${this.props.idEdit}/`,
                data: JSON.stringify({ campos: campos }),
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
            })
                .then((response) => {
                    if (response.data?.campos) {
                        detalhes['campos'] = response.data.campos_detalhes
                    }

                    this.props.setDetalhes(detalhes)
                    this.getCampos(response.data.campos_detalhes, detalhes.periodoTodo)
                    this.setState({ modal: false })
                })
                .catch(console.error)
        } else {
            detalhes['campos'] = itens
            this.props.setDetalhes(detalhes)
            this.toggleModal()
        }
    }

    handleChange = (key, value) => {
        let detalhes = Object.assign({}, this.props.detalhes)

        detalhes[key] = value

        this.props.setDetalhes(detalhes)
    }

    render() {
        const { campos } = this.state
        const estrutura = this.props.estrutura
        const styleFieldset = {
            fieldset: { margin: "10px 0px" },
            legend: { marginBottom: "0px" }
        }

        return (
            <>
                <HeaderConsumo
                    DataChange={this.props.detalhes}
                    toggleModal={() => this.setState({ modal: false })}
                    adicionar={this.adicionarCampos}
                    validacao={this.props.validacao}
                    modal={this.state.modal}
                    handleChange={this.handleChange}
                    order={true}
                    clientes={this.props.clientes}
                />

                <button data-tour="exportacao-gerenciar-parametros" style={{ position: "relative", width: "100%", height: "50px", background: "var(--fonte_titulo_abas)" }} className="hdv-btn-forms hdv-btn-green" onClick={() => { this.setState({ modal: true }) }}>Gerenciar Parâmetros</button>

                <div
                    style={{ display: campos.length > 0 ? "block" : "none" }}
                    data-tour="exportacao-estrutura"
                    data-preenchido={hasRealCampos(this.props.detalhes.campos) ? "true" : "false"}
                    data-tour-demo={this.state.tourDemoInjected ? "true" : "false"}>
                    {
                        this.userInfo?.tipo != "cliente" ?
                            <details style={styleFieldset.fieldset} open={true} className='custom-summary'>
                                <summary>Visualização cliente</summary>
                                <div style={{ padding: "15px 0px" }}>
                                    <div className="col-md-3">
                                        <label>Cliente</label>
                                        <Select
                                            disabled={true}
                                            value={this.props.detalhes.cliente}
                                            onChange={(selectedCliente) => this.handleChange('cliente', selectedCliente)}
                                            options={this.props.clientes}
                                        />
                                    </div>
                                </div>
                            </details>
                        : null
                    }

                    <ConfiguracoesDados
                        styleFieldset={styleFieldset}
                        detalhes={this.props.detalhes}
                        setDetalhes={(detalhes) => this.props.setDetalhes(detalhes)}
                        getCampos={(campos, periodoTodo) => this.getCampos(campos, periodoTodo)}
                    />

                    <ConfiguracoesEscalas
                        styleFieldset={styleFieldset}
                        estrutura={this.props.estrutura}
                        setEstrutura={(estrutura) => this.props.setEstrutura(estrutura)}
                        detalhes={this.props.detalhes}
                        campos={this.state.campos}
                        setCampos={(campos) => this.setState({campos})}
                        unidades={this.state.unidades}
                        setUnidades={(unidades) => this.setState({unidades})}
                    />

                    <ConfiguracoesColunas
                        styleFieldset={styleFieldset}
                        estrutura={this.props.estrutura}
                        setEstrutura={(estrutura) => this.props.setEstrutura(estrutura)}
                        detalhes={this.props.detalhes}
                        campos={this.state.campos}
                        setCampos={(campos) => this.setState({campos})}
                        unidades={this.state.unidades}
                        setUnidades={(unidades) => this.setState({unidades})}
                    />

                    <ConfiguracoesCabecalho
                        styleFieldset={styleFieldset}
                        estrutura={this.props.estrutura}
                        setEstrutura={(estrutura) => this.props.setEstrutura(estrutura)}
                    />

                    <ConfiguracoesGrupos
                        styleFieldset={styleFieldset}
                        estrutura={this.props.estrutura}
                        setEstrutura={(estrutura) => this.props.setEstrutura(estrutura)}
                    />

                    <PreVisualizacaoCabecalho
                        styleFieldset={styleFieldset}
                        estrutura={estrutura}
                        detalhes={this.props.detalhes}
                    />
                </div>
            </>
        )
    }
}

export const restoreExportacaoTourDemo = () => {
    if (!tourDemoRuntime.injected && !tourDemoRuntime.snapshot) {
        tourDemoRuntime.setDetalhes = null
        tourDemoRuntime.setEstrutura = null
        return
    }

    const snapshot = tourDemoRuntime.snapshot
    const setDetalhes = tourDemoRuntime.setDetalhes
    const setEstrutura = tourDemoRuntime.setEstrutura

    tourDemoRuntime.injected = false
    tourDemoRuntime.snapshot = null
    tourDemoRuntime.setDetalhes = null
    tourDemoRuntime.setEstrutura = null

    if (!snapshot) return

    const campos = (snapshot.campos || []).filter((campo) => !isExportacaoTourDemoCampo(campo))
    setDetalhes?.(Object.assign({}, snapshot.detalhes || {}, { campos }))
    setEstrutura?.(snapshot.estrutura)
}

export default CamposGrupos